__turbopack_context__.v({
  "alignStart": "PopoverPanel-module-scss-module__udDE0a__alignStart",
  "panel": "PopoverPanel-module-scss-module__udDE0a__panel",
  "popIn": "PopoverPanel-module-scss-module__udDE0a__popIn",
});
